'use client';

import MsalWrapper from "@components/MsalWrapper";
import MsalWrapperB2C from "@components/MsalWrapperB2C";
import ThemeRegistry from "@components/ThemeRegistry/ThemeRegistry";
import { LayoutProps } from "@lib/definitions";
import { isB2cUserLoggingIn } from "@utils/helpers";
import { useEffect, useState } from "react";


export default function RootLayout({ children }: Readonly<LayoutProps>) {

  const [isB2cUser, setIsB2cUser] = useState<boolean | null>(null);

  useEffect(() => {
    setIsB2cUser(isB2cUserLoggingIn());
  }, []);

  return (
    <html lang="en">
      <head>
        <title>Card Compliant Portal</title>
      </head>
      <body>

        <ThemeRegistry>
          {
            isB2cUser !== null && (
              isB2cUser
                ? <MsalWrapperB2C>{children}</MsalWrapperB2C>
                : <MsalWrapper>{children}</MsalWrapper>
            )
          }
        </ThemeRegistry>
      </body>
    </html>
  )
}